import { render, staticRenderFns } from "./AttentionList.vue?vue&type=template&id=abfe4c24&scoped=true"
import script from "./AttentionList.vue?vue&type=script&lang=ts"
export * from "./AttentionList.vue?vue&type=script&lang=ts"
import style0 from "./AttentionList.vue?vue&type=style&index=0&id=abfe4c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfe4c24",
  null
  
)

export default component.exports